import { createSelector } from "@reduxjs/toolkit";

export const archivesListState = (state) => state.archivesList;

export const archivesListSelectors = createSelector(archivesListState, (state) => state);
